export default "__VITE_ASSET__8v$QCuC1__"